<template>
  <div class="create-popup-container">
    <button
      type="button"
      data-test-id="header-button-create"
      class="btn text-white font-weight-bold header-focus-ring-trigger"
      ref="createTriggerRef"
      aria-label="Open create menu"
      aria-haspopup="dialog"
      :aria-expanded="state.modal.isVisible ? 'true' : 'false'"
      @click="toggleModal"
    >
      <i class="ri-apps-2-line" aria-hidden="true"></i>
      <span class="sr-only">Create</span>
    </button>
    <CModal
      class="overflow-auto"
      backdrop="static"
      size="xl"
      :visible="state.modal.isVisible"
      :close-on-backdrop="false"
      aria-labelledby="header-create-popup-title"
      :keyboard="true"
      @close="closeModal()"
    >
      <div
        class="pt-4 px-4 create-popup-header d-flex align-items-center justify-content-between"
      >
        <HelpCenterButton
          data-test-id="header-button-help-center"
          v-if="state.modal.activeModalTab"
          :content-key="helpCenterKey"
          :aria-label="helpCenterButtonAriaLabel"
        />
        <h2
          id="header-create-popup-title"
          class="create-popup-container-text mb-0"
        >
          Create
        </h2>
        <button
          data-test-id="header-button-close-modal"
          ref="closeModalButtonRef"
          type="button"
          class="d-inline-block text-black p-1 lh-normal cursor-pointer bg-transparent border-0 header-focus-ring-trigger"
          aria-label="Close create modal"
          @click="closeModal()"
        >
          <i class="ri-close-line" aria-hidden="true"></i>
        </button>
      </div>

      <div
        v-if="
          !state.modal.activeModalTab || state.modal.activeModalTab === 'all'
        "
        class="px-0 px-md-4 pb-4 text-center"
      >
        <CContainer>
          <div class="create-box-grid" :class="gridClasses">
            <div
              class="create-box-grid"
              :class="{
                'create-box-col-span-2':
                  !isActiveKioskModule && !isActiveAppoinmentModule
              }"
            >
              <div
                class="create-box mr-2 cursor-pointer"
                role="button"
                tabindex="0"
                @click="setActiveTab('teacher_pass_pop_up')"
                @keydown.enter.prevent="setActiveTab('teacher_pass_pop_up')"
                @keydown.space.prevent="setActiveTab('teacher_pass_pop_up')"
                data-test-id="header-button-teacher-pass"
              >
                <div class="text-center mb-3">
                  <i class="small ri-door-open-line"></i>
                </div>
                <div class="create-box-text text-center">
                  Teacher Pass<br />
                  <div class="create-box-text-help">(TCH)</div>
                </div>
              </div>
              <div
                v-if="isActiveAppoinmentModule"
                class="create-box cursor-pointer"
                role="button"
                tabindex="0"
                @click="setActiveTab('appointment_pass_pop_up')"
                @keydown.enter.prevent="setActiveTab('appointment_pass_pop_up')"
                @keydown.space.prevent="setActiveTab('appointment_pass_pop_up')"
                data-test-id="header-button-appointment-pass"
              >
                <div class="text-center mb-3">
                  <i class="small ri-calendar-check-line"></i>
                </div>
                <div class="create-box-text text-center">
                  Appointment Pass
                  <div class="create-box-text-help">(APT)</div>
                </div>
              </div>
            </div>

            <div class="create-box-grid">
              <div
                data-test-id="header-button-ooo"
                class="create-box cursor-pointer"
                role="button"
                tabindex="0"
                @click="setActiveTab('out_of_office_pop_up')"
                @keydown.enter.prevent="setActiveTab('out_of_office_pop_up')"
                @keydown.space.prevent="setActiveTab('out_of_office_pop_up')"
              >
                <div class="text-center mb-3">
                  <i class="small ri-suitcase-3-line"></i>
                </div>
                <div class="create-box-text text-center">Out of Office</div>
              </div>
              <div
                v-if="isActiveKioskModule"
                data-test-id="header-button-activate-kiosk"
                class="create-box cursor-pointer"
                role="button"
                tabindex="0"
                @click="goToPage('/kiosk')"
                @keydown.enter.prevent="goToPage('/kiosk')"
                @keydown.space.prevent="goToPage('/kiosk')"
              >
                <div class="text-center mb-3">
                  <i class="small ri-device-line"></i>
                </div>
                <div class="create-box-text text-center">Activate Kiosk</div>
              </div>
            </div>

            <div
              v-if="isVisitorManagementAval"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              :class="{
                'col-span-2': !isActiveKioskModule && !isActiveAppoinmentModule
              }"
              @click="$router.push('/visitor/management/check-ins-and-logs')"
              @keydown.enter.prevent="
                $router.push('/visitor/management/check-ins-and-logs')
              "
              @keydown.space.prevent="
                $router.push('/visitor/management/check-ins-and-logs')
              "
            >
              <div class="text-center mb-3">
                <i class="small ri-user-add-line"></i>
              </div>
              <div class="create-box-text text-center">Visitor Check-in</div>
            </div>
          </div>

          <h3
            class="other-links h6 mb-3 mt-3 justify-content-center text-center"
          >
            Other links
          </h3>
          <CRow v-if="userRole === 'admin'" class="create-limits-container">
            <CCol
              data-test-id="header-button-concat-control"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              @click="setActiveTab('a_b_polarity_pop_up')"
              @keydown.enter.prevent="setActiveTab('a_b_polarity_pop_up')"
              @keydown.space.prevent="setActiveTab('a_b_polarity_pop_up')"
            >
              <div class="create-box-icon text-center mb-1">
                <i class="ri-a-b"></i>
              </div>
              <div class="create-box-text text-center">Contact Control</div>
            </CCol>
            <CCol
              data-test-id="header-button-limit-location-max-cap"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              @click="setActiveTab('limit_location_max_cap_pop_up')"
              @keydown.enter.prevent="
                setActiveTab('limit_location_max_cap_pop_up')
              "
              @keydown.space.prevent="
                setActiveTab('limit_location_max_cap_pop_up')
              "
            >
              <div class="text-center mb-1">
                <i class="ri-team-line"></i>
              </div>
              <div class="create-box-text text-center">
                Limit Location Max Cap
              </div>
            </CCol>
            <CCol
              data-test-id="header-button-limit-location-availability"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              @click="setActiveTab('limit_local_availability_pop_up')"
              @keydown.enter.prevent="
                setActiveTab('limit_local_availability_pop_up')
              "
              @keydown.space.prevent="
                setActiveTab('limit_local_availability_pop_up')
              "
            >
              <div class="text-center mb-1">
                <i class="ri-map-pin-5-line"></i>
              </div>
              <div class="create-box-text text-center">
                Limit Location Availability
              </div>
            </CCol>
            <CCol
              data-test-id="header-button-limit-student-pass"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              @click="setActiveTab('limit_students_passes_pop_up')"
              @keydown.enter.prevent="
                setActiveTab('limit_students_passes_pop_up')
              "
              @keydown.space.prevent="
                setActiveTab('limit_students_passes_pop_up')
              "
            >
              <div class="text-center mb-1">
                <i class="ri-traffic-light-line"></i>
              </div>
              <div class="create-box-text text-center">Limit Student Pass</div>
            </CCol>
            <CCol
              data-test-id="header-button-limit-active-pass"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              @click="setActiveTab('limit_acive_passes_pop_up')"
              @keydown.enter.prevent="setActiveTab('limit_acive_passes_pop_up')"
              @keydown.space.prevent="setActiveTab('limit_acive_passes_pop_up')"
            >
              <div class="text-center mb-1">
                <i class="ri-door-closed-line"></i>
              </div>
              <div class="create-box-text text-center">
                Limit Active Pass
              </div> </CCol
            ><CCol
              data-test-id="header-button-pass-blocking"
              class="create-box cursor-pointer"
              role="button"
              tabindex="0"
              aria-label="Pass Blocking"
              @click="setActiveTab('pass_blocking_pop_up')"
              @keydown.enter.prevent="setActiveTab('pass_blocking_pop_up')"
              @keydown.space.prevent="setActiveTab('pass_blocking_pop_up')"
            >
              <div class="text-center mb-1">
                <i class="ri-lock-line"></i>
              </div>
              <div class="create-box-text text-center">Pass Blocking</div>
            </CCol>
          </CRow>
          <CRow v-if="userRole === 'admin'" class="quick-links-container">
            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-polarity-report"
            >
              <router-link to="/limits/ab-polarity">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-group-line"></i>Polarity Report
                  </div>
                </CCol>
              </router-link>
            </CCol>

            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-pass-history"
            >
              <router-link to="/history">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-history-line"></i>
                    Pass History
                  </div>
                </CCol>
              </router-link>
            </CCol>
          </CRow>
          <CRow
            v-if="userRole === 'teacher' || userRole === 'staff'"
            class="quick-links-container-teacher-staff"
          >
            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-pass-history"
            >
              <router-link to="/history">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-history-line"></i>
                    Pass History
                  </div>
                </CCol>
              </router-link>
            </CCol>
          </CRow>
          <CRow v-if="userRole === 'admin'" class="quick-links-container">
            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-summary-report"
            >
              <router-link to="/reports/summary-reports">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-book-read-line"></i>
                    Summary Report
                  </div>
                </CCol>
              </router-link>
            </CCol>
            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-contact-tracing"
            >
              <router-link to="/reports/meet-up-report">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-parent-line"></i>
                    Meet-up Report
                  </div>
                </CCol>
              </router-link>
            </CCol>
            <CCol
              class="create-custom-box cursor-pointer"
              data-test-id="header-button-help-desk"
            >
              <router-link to="/help-desk">
                <CCol>
                  <div class="create-custom-box-text">
                    <i class="ri-parent-line"></i>
                    Help Desk
                  </div>
                </CCol>
              </router-link>
            </CCol>
          </CRow>
        </CContainer>
      </div>

      <div v-if="state.modal.activeModalTab" class="create-modals">
        <div
          v-if="state.modal.activeModalTab === 'teacher_pass_pop_up'"
          class="text-center px-5"
        >
          <h2 class="mb-2">Teacher Pass Pop-up</h2>
          <CreateTeacherPassForm @close-modal="closeModal()" />
        </div>
        <div
          v-if="
            isActiveAppoinmentModule &&
            state.modal.activeModalTab === 'appointment_pass_pop_up'
          "
          class="text-center px-5"
        >
          <h2 class="mb-4">Appointments Pop-up</h2>
          <CreateAppoinmentsPassForm
            form-index="0"
            :periods="periods"
            :is-header-create-button="true"
            @close-modal="closeModal()"
          />
        </div>
        <div
          v-if="state.modal.activeModalTab === 'out_of_office_pop_up'"
          class="text-center px-5"
        >
          <h2 class="mb-4">Out Of Office Pop-up</h2>
          <OutOfOfficeForm
            :is-header-create-button="true"
            @cancel="closeModal()"
          />
        </div>
        <div v-if="userRole === 'admin'">
          <div
            v-if="state.modal.activeModalTab === 'a_b_polarity_pop_up'"
            class="text-center px-5"
          >
            <h2 class="mb-4">Contact Control (A/B Polarity) Pop-up</h2>
            <CreateContactControlForm
              :is-header-create-button="true"
              @close-modal="closeModal()"
            />
          </div>
          <div
            v-if="
              state.modal.activeModalTab === 'limit_location_max_cap_pop_up'
            "
            class="text-center px-5"
          >
            <h2 class="mb-4">Limit Location Max Cap Pop-up</h2>
            <CreateLimitLocationMaxCapForm
              :is-dashboard-view="true"
              :is-header-create-button="true"
              @close-modal="closeModal()"
            />
          </div>
          <div
            v-if="
              state.modal.activeModalTab === 'limit_local_availability_pop_up'
            "
            class="text-center px-5"
          >
            <h2 class="mb-4">Limit Location Availability Pop-up</h2>
            <CreateLimitLocationAvailabilityForm @close-modal="closeModal()" />
          </div>
          <div
            v-if="state.modal.activeModalTab === 'limit_students_passes_pop_up'"
            class="text-center px-5"
          >
            <h2 class="mb-4">Limit Student(s) Passes Pop-up</h2>
            <CreateLimitStudentPassForm
              :is-in-view="false"
              @close-modal="closeModal()"
            />
          </div>
          <div
            v-if="state.modal.activeModalTab === 'limit_acive_passes_pop_up'"
            class="px-5"
          >
            <h2 class="mb-4">Limit Active Passes Pop-up</h2>
            <LimitActivePassForm @close-modal="closeModal()" />
          </div>
          <div
            v-if="state.modal.activeModalTab === 'pass_blocking_pop_up'"
            class="text-center px-5"
            role="group"
            aria-labelledby="pass-blocking-popup-heading"
          >
            <h2 id="pass-blocking-popup-heading" class="mb-4">
              Pass blocking Pop-up
            </h2>
            <CreatePassBlockingForm
              :is-header-create-button="true"
              @close-modal="closeModal()"
            />
          </div>
        </div>
      </div>

      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  watch,
  onMounted,
  onUnmounted,
  nextTick,
  ref,
  inject
} from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import CreateTeacherPassForm from "@/v3components/Forms/CreateTeacherPassForm.vue"
import CreateAppoinmentsPassForm from "@/v3components/Forms/CreateAppointmentPassMultipleForm.vue"
import OutOfOfficeForm from "@/v3components/Forms/OutOfOfficeForm.vue"
import CreateContactControlForm from "@/v3components/Forms/CreateContactControlForm.vue"
import CreateLimitLocationMaxCapForm from "@/v3components/Forms/CreateLimitLocationMaxCapForm.vue"
import CreateLimitLocationAvailabilityForm from "@/v3components/Forms/CreateLimitLocationAvailabilityForm.vue"
import CreateLimitStudentPassForm from "@/v3components/Forms/CreateLimitStudentPassForm.vue"
import CreatePassBlockingForm from "@/v3components/Forms/CreatePassBlockingForm.vue"
import LimitActivePassForm from "@/v3components/Forms/LimitActivePassForm.vue"
import HelpCenterButton from "@/v3components/HelpCenterButton.vue"
import { shouldDeferModalEscape } from "@/helpers/isPickerOverlayOpen"

export default {
  name: "TheHeaderCreateButton",
  components: {
    CreateTeacherPassForm,
    CreateAppoinmentsPassForm,
    OutOfOfficeForm,
    CreateContactControlForm,
    CreateLimitLocationMaxCapForm,
    CreateLimitLocationAvailabilityForm,
    CreateLimitStudentPassForm,
    CreatePassBlockingForm,
    LimitActivePassForm,
    HelpCenterButton
  },
  props: {
    userRole: {
      type: String,
      required: true
    }
  },
  setup() {
    const createTriggerRef = ref(null)
    const closeModalButtonRef = ref(null)
    const lastFocusedElement = ref(null)
    const headerCreateModalOpen = inject("headerCreateModalOpen", null)

    const getOpenCreateModalRoot = () =>
      document.querySelector(".create-popup-container .modal.show")

    const getModalFocusableElements = () => {
      const modalElement = getOpenCreateModalRoot()
      if (!modalElement) return []

      const selector = [
        "button:not([disabled])",
        "[href]",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "[tabindex]:not([tabindex='-1'])"
      ].join(",")

      return Array.from(modalElement.querySelectorAll(selector)).filter(
        (element) => {
          const computedStyle = window.getComputedStyle(element)
          return (
            computedStyle.display !== "none" &&
            computedStyle.visibility !== "hidden" &&
            (element.offsetWidth > 0 || element.offsetHeight > 0)
          )
        }
      )
    }

    const moveFocusIntoModal = () => {
      nextTick(() => {
        if (closeModalButtonRef.value) {
          closeModalButtonRef.value.focus()
          return
        }
        const [firstFocusable] = getModalFocusableElements()
        firstFocusable?.focus?.()
      })
    }

    const isEscapePress = (event) => {
      return (
        event?.key === "Escape" ||
        event?.key === "Esc" ||
        event?.code === "Escape" ||
        event?.keyCode === 27
      )
    }

    const restoreFocusToTrigger = () => {
      const focusTarget = lastFocusedElement.value || createTriggerRef.value
      if (focusTarget && typeof focusTarget.focus === "function") {
        nextTick(() => {
          try {
            focusTarget.focus()
          } catch {
            // no-op: element may no longer be focusable
          }
        })
      }
      lastFocusedElement.value = null
    }

    const onDocumentKeydown = (event) => {
      if (!state.modal.isVisible) return

      if (isEscapePress(event)) {
        if (shouldDeferModalEscape(event)) {
          return
        }
        event.preventDefault()
        event.stopPropagation()
        closeModal()
        return
      }

      if (event.key !== "Tab") return

      const modalRoot = getOpenCreateModalRoot()
      const focusableElements = getModalFocusableElements()
      if (!focusableElements.length) {
        event.preventDefault()
        const rootFocusable =
          modalRoot && typeof modalRoot.focus === "function" ? modalRoot : null
        const focusTarget = rootFocusable || closeModalButtonRef.value
        if (focusTarget && typeof focusTarget.focus === "function") {
          try {
            if (rootFocusable) {
              rootFocusable.setAttribute("tabindex", "-1")
            }
            focusTarget.focus()
          } catch {
            // no-op: transient DOM during CoreUI modal transition
          }
        }
        return
      }

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]
      const activeElement = document.activeElement

      if (modalRoot && activeElement && !modalRoot.contains(activeElement)) {
        event.preventDefault()
        ;(event.shiftKey ? lastElement : firstElement).focus()
        return
      }

      if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      } else if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      }
    }

    const onDocumentFocusIn = (event) => {
      if (!state.modal.isVisible) return

      const modalRoot = getOpenCreateModalRoot()
      if (!modalRoot) return

      const activeTarget = event?.target
      if (!activeTarget || modalRoot.contains(activeTarget)) return

      const focusableElements = getModalFocusableElements()
      const [firstElement] = focusableElements
      ;(firstElement || closeModalButtonRef.value)?.focus?.()
    }

    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const state = reactive({
      modal: {
        isVisible: false,
        activeModalTab: "all",
        size: "lg"
      }
    })

    const gridClasses = computed(() => {
      // If Visitor Management is not available
      if (!isVisitorManagementAval.value) {
        // If only the Kiosk Module is active
        if (isActiveKioskModule.value && !isActiveAppoinmentModule.value) {
          return "create-box-grid-cols-2"
        }

        // If only the Appointment module is active
        if (!isActiveKioskModule.value && isActiveAppoinmentModule.value) {
          return "create-box-grid-cols-2"
        }

        // Return 2 columns if both Kiosk and Appointment modules are active, else 1 column
        return isActiveKioskModule.value && isActiveAppoinmentModule.value
          ? "create-box-grid-cols-2"
          : "create-box-grid-cols-1"
      }

      // Return 3 columns if Visitor Management is available and Kiosk is not active
      if (isActiveAppoinmentModule.value && !isActiveKioskModule.value) {
        return "create-box-grid-cols-3"
      }

      // If Visitor Management is available but Kiosk Module is not active
      if (!isActiveKioskModule.value) {
        return "create-box-grid-cols-2"
      }

      // Default to 3 columns if Visitor Management and Kiosk Module are active
      return "create-box-grid-cols-3"
    })

    const periods = computed(() => {
      return store.getters["periods/formListStudents"]
    })

    const isActiveAppoinmentModule = computed(() => {
      return store.getters["schools/isActiveAppoinmentModule"]
    })

    const isActiveKioskModule = computed(() => {
      return store.getters["schools/isActiveKioskModule"]
    })

    const isVisitorModuleActive = computed(() => {
      return store.getters["schools/isVisitorModuleActive"]
    })

    const helpCenterKey = computed(() => {
      return state.modal.activeModalTab === "all"
        ? "user_menu_create_button"
        : state.modal.activeModalTab
    })

    const helpCenterButtonAriaLabel = computed(() => {
      const tabName = String(state.modal.activeModalTab || "create menu")
        .replaceAll("_", " ")
        .replaceAll("-", " ")
      return `Open Help Center for ${tabName}`
    })

    const isVisitorManagementAval = computed(() => {
      return (
        isVisitorModuleActive.value &&
        store.getters["visitorSettings/hasVisitorCreateMenuAccess"]
      )
    })

    watch(
      () => route.path,
      () => {
        closeModal()
      }
    )

    onMounted(() => {
      store.dispatch("periods/getPeriods")
      store.dispatch("rooms/getUserAssignRooms")
    })

    const setActiveTab = (tab, size = null) => {
      if (route.path.includes(tab)) {
        closeModal()
      } else {
        state.modal.activeModalTab = tab
        state.modal.size = size
      }
    }

    const closeModal = () => {
      state.modal.isVisible = false
      setTimeout(() => {
        state.modal.activeModalTab = "all"
        state.modal.size = "xl"
      }, 500)
      toggleBodyScroll(false)
      restoreFocusToTrigger()
    }

    const toggleBodyScroll = (isVisible) => {
      const body = document.getElementsByTagName("body")[0]
      if (isVisible) {
        body.classList.add("overflow-hidden")
      } else {
        body.classList.remove("overflow-hidden")
      }
    }

    const goToPage = (page) => {
      if (route.path !== page) {
        router.push(page)
      }
      closeModal()
    }

    const toggleModal = () => {
      if (!state.modal.isVisible) {
        lastFocusedElement.value = document.activeElement
      }
      state.modal.isVisible = !state.modal.isVisible
      toggleBodyScroll(state.modal.isVisible)
    }

    watch(
      () => state.modal.isVisible,
      (isVisible) => {
        if (headerCreateModalOpen && "value" in headerCreateModalOpen) {
          headerCreateModalOpen.value = isVisible
        }
        if (isVisible) {
          moveFocusIntoModal()
        }
      }
    )

    document.addEventListener("keydown", onDocumentKeydown, true)
    document.addEventListener("focusin", onDocumentFocusIn, true)
    onUnmounted(() => {
      document.removeEventListener("keydown", onDocumentKeydown, true)
      document.removeEventListener("focusin", onDocumentFocusIn, true)
    })

    return {
      state,
      createTriggerRef,
      closeModalButtonRef,
      periods,
      gridClasses,
      isActiveAppoinmentModule,
      isActiveKioskModule,
      helpCenterKey,
      helpCenterButtonAriaLabel,
      setActiveTab,
      isVisitorManagementAval,
      closeModal,
      toggleBodyScroll,
      goToPage,
      toggleModal
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.create-popup-container :deep(button:focus-visible),
.create-popup-container :deep(a:focus-visible),
.create-popup-container :deep([role="button"]:focus-visible) {
  outline: 2px solid $outline-color;
  outline-offset: $outline-offset;
}

/* Large tiles: outline alone is easy to lose on blue — add inner contrast ring
   (same idea as header buttons, 1rem radius). WCAG 2.4.7 without full color invert. */
.create-popup-container :deep(.create-box:focus-visible),
.create-popup-container .create-box:focus-visible {
  outline: 3px solid $outline-color;
  outline-offset: 2px;
  border-radius: 1rem;
  box-shadow:
    0 0 0 2px rgba(255, 255, 255, 0.95),
    0 0 0 6px $outline-color;
  position: relative;
  z-index: 1;
}

.create-popup-container :deep(.create-custom-box:focus-within) {
  outline: 2px solid $outline-color;
  outline-offset: $outline-offset;
}
</style>
